import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal, Form, Card, Spinner, Alert } from 'react-bootstrap';
import api from './api';

function KategoriYonetimi() {
  const [kategoriler, setKategoriler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenKategori, setDuzenlenenKategori] = useState(null);

  const kategorileriGetir = useCallback(async () => {
    try {
      const response = await api.get('/diyetisyen/kategoriler');
      setKategoriler(response.data);
    } catch (err) {
      setError("Kategoriler yüklenirken bir hata oluştu.");
      console.error("Kategoriler getirilemedi:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { kategorileriGetir(); }, [kategorileriGetir]);

  const handleSil = async (kategoriId) => {
    if (!window.confirm('Bu kategoriyi silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/diyetisyen/kategoriler/${kategoriId}`);
      kategorileriGetir();
    } catch (err) {
      alert(err.response?.data?.mesaj || 'Silme işlemi başarısız');
    }
  };
  
  const handleModalOpen = (kategori = null) => {
    setDuzenlenenKategori(kategori);
    setShowModal(true);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const ad = e.target.elements.ad.value;
    const isUpdating = !!duzenlenenKategori?.id;
    const url = isUpdating ? `/diyetisyen/kategoriler/${duzenlenenKategori.id}` : '/diyetisyen/kategoriler';
    const method = isUpdating ? 'put' : 'post';
    try {
      await api[method](url, { ad });
      setShowModal(false);
      kategorileriGetir();
    } catch (err) {
      alert(`Hata: ${err.response?.data?.mesaj || 'İşlem başarısız'}`);
    }
  };

  if (loading) return <Spinner animation="border" variant="light" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Card className="glass-card text-white">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title as="h5">Kategori Listesi</Card.Title>
          <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Kategori Ekle</Button>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Ad</th>
                <th style={{ width: '150px' }} className="text-end">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {kategoriler.map((kategori) => (
                <tr key={kategori.id}>
                  <td data-label="Ad">{kategori.ad}</td>
                  <td data-label="İşlemler" className="text-end">
                    <Button variant="warning" size="sm" onClick={() => handleModalOpen(kategori)}>Düzenle</Button>
                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(kategori.id)}>Sil</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{duzenlenenKategori?.id ? 'Kategori Düzenle' : 'Yeni Kategori Ekle'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleFormSubmit}>
            <Form.Group>
              <Form.Label>Kategori Adı</Form.Label>
              <Form.Control name="ad" type="text" defaultValue={duzenlenenKategori?.ad || ''} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={() => setShowModal(false)} className="me-2">İptal</Button>
              <Button variant="primary" type="submit">Kaydet</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Card>
  );
}
export default KategoriYonetimi;